import { useCallback, useState } from 'react';
import { operatorConsole, type MediaKitAsset } from '../../lib/api/operatorConsole';
import { assetErrorMessage } from './mediaKitErrors';
import { triggerDownload } from './triggerDownload';

export function useAssetDownload(packId: number, asset: MediaKitAsset) {
  const [pending, setPending] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { id, kind } = asset;

  const download = useCallback(async () => {
    setPending(true);
    setError(null);
    try {
      const { url } = await operatorConsole.mediaKit.assetDownload(packId, id);
      triggerDownload(url);
    } catch (err) {
      setError(assetErrorMessage(err, kind));
    } finally {
      setPending(false);
    }
  }, [packId, id, kind]);

  return { pending, error, download };
}
